import { CoreMenu } from "@core/types";
import { User } from "app/auth/models";
import { userToMenu } from "app/main/oauth/return-oauth/return-oauth.component";

export function generateMenu(currentUser: User, currentCompany: number) {
  let menu: CoreMenu[] = [];
  let permissaoPoliticaCompliance;
  let permissaoInformacoesCompliance;
  let permissaoAuditoria;
  let permissaoRelatorios;
  let permissaoPermissoes;
  let permissaoGruposUsuario;
  let permissaoTreinamentos;

  let disabledItensAdmin: boolean = false;

  if(userToMenu.admin) {
    for (let i = 0; i < userToMenu.permissoes.length; i++) {
      switch (userToMenu.permissoes[i].funcionalidadeNome) {
        case "Políticas de Compliance":
          permissaoPoliticaCompliance = userToMenu.permissoes[i];
          break;
        case "Informações de Compliance":
          permissaoInformacoesCompliance = userToMenu.permissoes[i];
          break;
        case "Treinamentos":
          permissaoTreinamentos = userToMenu.permissoes[i];
          break;
        case "Auditoria":
          permissaoAuditoria = userToMenu.permissoes[i];
          break;
        case "Relatórios":
          permissaoRelatorios = userToMenu.permissoes[i];
          break;
        case "Permissões":
          permissaoPermissoes = userToMenu.permissoes[i];
          break;
        case "Grupos e Usuários":
          permissaoGruposUsuario = userToMenu.permissoes[i];
          break;
      }
    }
  }

  if (currentUser.superAdmin == true) {
    if (currentCompany != 0) {
      menu.push({
        id: "gerenciando",
        type: "section",
        title:`${currentUser.empresaNome}`,
        icon: null,
        children: [
          {
            id: "gerenciando-title",
            type: "item",
            title: "",
            icon: null,
            hasSrc: true,
            src: currentUser.empresaMidiaCaminho,
            disabled: true,
            url: "#",
          },
        ],
      });
    } else {
      disabledItensAdmin = true;
    }

    menu.push(
      {
        id: "painel-administrativo",
        type: "collapsible",
        title: "Painel Administrativo",
        icon: null,
        children: [
          {
            id: "clientes",
            title: "Clientes",
            type: "item",
            icon: "circle",
            url: "admin/painel-administrativo/clientes",
          },
          {
            id: "panel-trainings",
            title: "Treinamentos",
            type: "item",
            icon: "circle",
            url: "admin/painel-administrativo/trainings-super",
          },
          {
            id: "panel-permissions",
            title: "Usuários",
            type: "item",
            icon: "circle",
            url: "admin/painel-administrativo/permissao",
          },
        ],
      },
      {
          id: "dashboard",
          title: "Dashboard",
          type: "item",
          icon: null,
          url: "admin/home",
          translate: "MENU.DASHBOARD",
          disabled:
              disabledItensAdmin      
      },
      {
        id: "gestaoconteudo",
        type: "collapsible",
        title: "Gestão de Conteúdo",
        icon: null,
        children: [
          {
            id: "politicas",
            title: "Políticas de Compliance",
            type: "item",
            icon: "circle",
            url: "admin/politicas",
            disabled:
              disabledItensAdmin ||
              !currentUser.empresaAcessoPoliticasCompliance,
          },
          {
            id: "treinamentos",
            title: "Treinamentos",
            type: "item",
            icon: "circle",
            url: "admin/trainings",
            disabled:
            disabledItensAdmin || !currentUser.empresaAcessoTreinamentos,
          },
          {
            id: "informacoes",
            title: "Informações de Compliance",
            type: "item",
            icon: "circle",
            url: "admin/compliance-information",
            disabled:
              disabledItensAdmin ||
              !currentUser.empresaAcessoInformacoesCompliance,
          },
        ],
      },
      {
        id: "Auditoria",
        title: "Auditoria",
        type: "item",
        icon: null,
        url: "admin/auditoria",
        disabled: disabledItensAdmin,
      },
      {
        id: "permissoes",
        type: "item",
        title: "Permissões",
        icon: null,
        url: "admin/permissoes",
        disabled: disabledItensAdmin,
      },
      {
        id: "relatorios",
        type: "collapsible",
        title: "Relatórios",
        icon: null,
        children: [
          {
            id: "politica-relatorio",
            title: "Políticas de Compliance",
            type: "item",
            icon: "circle",
            url: "admin/relatorios/politicas-de-compliance",
            disabled:
            disabledItensAdmin ||
              !currentUser.empresaAcessoPoliticasCompliance,
          },
          {
            id: "treinamentos",
            title: "Treinamentos",
            type: "item",
            icon: "circle",
            url: "admin/relatorios/treinamentos",
            disabled:
            disabledItensAdmin || !currentUser.empresaAcessoTreinamentos,
          },
          {
            id: "informacoes-relatorio",
            title: "Informações de Compliance",
            type: "item",
            icon: "circle",
            url: "admin/relatorios/informacoes-de-compliance",
            disabled:
            disabledItensAdmin ||
              !currentUser.empresaAcessoInformacoesCompliance,
          },
          {
            id: "agendamento-reuniao",
            title: "Reuniões com Agentes Públicos",
            type: "item",
            icon: "circle",
            url: "admin/relatorios/reporte-reuniao",
            disabled : disabledItensAdmin || !currentUser.empresaAcessoAgendamentoReunioes
          },
        ],
      },
      {
        id: "grupos-de-usuarios",
        title: "Grupos de Usuários",
        type: "item",
        icon: null,
        url: "admin/grupos-de-usuarios",
        disabled: disabledItensAdmin,
      }
    );
  } else {
    // menuAdmin
    menu.push(
      {
        id: "dashboard",
        title: "Dashboard",
        type: "item",
        icon: null,
        url: "admin/home",
        translate: "MENU.DASHBOARD",
        disabled:
            disabledItensAdmin      
      },
      {
        id: "gestaoconteudo",
        type: "collapsible",
        title: "Gestão de Conteúdo",
        icon: null,
        children: [
          {
            id: "politicas",
            title: "Políticas de Compliance",
            type: "item",
            icon: "circle",
            url: "admin/politicas",
            disabled:
              !permissaoPoliticaCompliance?.visualizar ||
              !currentUser.empresaAcessoPoliticasCompliance,
          },
          {
            id: "treinamentos",
            title: "Treinamentos",
            type: "item",
            icon: "circle",
            url: "admin/trainings",
            disabled:
              disabledItensAdmin || !currentUser.empresaAcessoTreinamentos,
          },
          {
            id: "informacoes",
            title: "Informações de Compliance",
            type: "item",
            icon: "circle",
            url: "admin/compliance-information",
            disabled:
              !permissaoInformacoesCompliance?.visualizar ||
              !currentUser.empresaAcessoInformacoesCompliance,
          },
        ],
      },
      {
        id: "Auditoria",
        title: "Auditoria",
        type: "item",
        icon: null,
        url: "admin/auditoria",
        disabled: !permissaoAuditoria?.visualizar,
      },
      {
        id: "permissoes",
        type: "item",
        title: "Permissões",
        icon: null,
        url: "admin/permissoes",
        disabled: !permissaoPermissoes?.visualizar,
      },
      {
        id: "relatorios",
        type: "collapsible",
        title: "Relatórios",
        icon: null,
        children: [
          {
            id: "politica-relatorio",
            title: "Políticas de Compliance",
            type: "item",
            icon: "circle",
            url: "admin/relatorios/politicas-de-compliance",
            disabled:
            !permissaoRelatorios?.visualizar ||
              !currentUser.empresaAcessoPoliticasCompliance,
          },
          {
            id: "treinamentos",
            title: "Treinamentos",
            type: "item",
            icon: "circle",
            url: "admin/relatorios/treinamentos",
            disabled:
            !permissaoRelatorios?.visualizar || !currentUser.empresaAcessoTreinamentos,
          },
          {
            id: "informacoes-relatorio",
            title: "Informações de Compliance",
            type: "item",
            icon: "circle",
            url: "admin/relatorios/informacoes-de-compliance",
            disabled:
            !permissaoRelatorios?.visualizar ||
              !currentUser.empresaAcessoInformacoesCompliance,
          },
          {
            id: "agendamento-reuniao",
            title: "Reuniões com Agentes Públicos",
            type: "item",
            icon: "circle",
            url: "admin/relatorios/reporte-reuniao",
            disabled : disabledItensAdmin || !currentUser.empresaAcessoAgendamentoReunioes
          },
        ],
      },
      {
        id: "grupos-de-usuarios",
        title: "Grupos de Usuários",
        type: "item",
        icon: null,
        url: "admin/grupos-de-usuarios",
        disabled: !permissaoGruposUsuario?.visualizar,
      },
      {
        id: "configuracao",
        type: "item",
        title: "Configurações",
        icon: null,
        url: "admin/configuracao",
        disabled: disabledItensAdmin,
      }
    );
  }
  return menu;
}

export const menuDeloitte: CoreMenu[] = [];

